import { PureConnect, React } from '../../react';
import {  IBookmark, IEntity } from '../../types';
import { categoriesResource } from '../categories/resource';
import { selectors } from '../../meta/selectors';
import cx from './style.less';
import { bookmarksEditor } from '../bookmarks/resource';
import MiniMenu, { MiniMenuItem } from '../../react-toolbox-extended/mini-menu';
import REFRESH_BOOKMARKUPDATE from '../notemenu/actions/REFRESH_BOOKMARKUPDATE';
import TOGGLE_NOTEMENU from '../notes/actions/NOTES_TOGGLE_NOTEMENU';

interface IBookmarkProps {
    item: IBookmark;
    visible?: boolean;
}

export default PureConnect<any|IBookmarkProps>('DataItemNote')(
    (state, props) => ({
        categories: categoriesResource.selectors.items(state),
        docId: selectors.docId(state),
        pageId: selectors.pageId(state),
        showMiniMenu: state.notesReducer.showMiniMenu,
        itemMiniMenu: state.notesReducer.itemMiniMenu,
    }),
    (dispatch) => ({
        selectBookmark: (bookmark: IBookmark) => dispatch(bookmarksEditor.actions.READ({ item: bookmark })),
        removeBookmark: (item: IBookmark) => dispatch(REFRESH_BOOKMARKUPDATE({ item, add: false })),
        toggleMiniMenu: (showMiniMenu: boolean, itemMiniMenu: IEntity) => {         
                                dispatch(TOGGLE_NOTEMENU({ showMiniMenu, itemMiniMenu })); 
                            },
    }),
    ({ item, visible, showMiniMenu, removeBookmark, selectBookmark, toggleMiniMenu, itemMiniMenu }) => {

        const onClickItem = () => {
                selectBookmark(item);
        };
        
        const onKeyDownNotTab = (ev: React.KeyboardEvent<HTMLDivElement>) => {
            if (ev.key==='Enter') {
                onClickItem();
            }
        };

        const toggle = () => {
            showMiniMenu=!showMiniMenu;
            toggleMiniMenu(showMiniMenu, item);
        }; 

        const itms: MiniMenuItem[] = 
        [ { name:'Verwijderen', iconName:'delete', key:'1', functionitem:item, function: (item: IBookmark) => {
            return removeBookmark(item);
        }} ];

        return ( 
            <li className={cx('data-item')}>
                <div className={cx('bookmark-status')}></div>
                <div className={cx('bookmark')}> 
                    <div className={cx('icon-left-container')}>
                        <span className={cx('icon-container', 'bookmark')} onClick={onClickItem}></span>
                    </div>
                    <div className={cx('text-container')} tabIndex={visible? -1: 0} onKeyDown={(event) => onKeyDownNotTab(event)} onClick={onClickItem}>
                        <div className={cx('text-container_main')}>{item.name}</div>
                    </div>
                    <div className={cx('minimenu-container')}>
                        <MiniMenu showMiniMenu={showMiniMenu && (item.id === (itemMiniMenu ? itemMiniMenu.id : ''))} 
                                toggleMiniMenu={() => toggle()}
                                items={itms}>
                        </MiniMenu>
                    </div>
                </div>
            </li>
        );
    },
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/dataitembookmark/index.tsx